import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmailClientComponent } from "./email-client/email-client.component";
import { EmailRoutingModule } from "./email-routing.module";
import { OutlookEmailClientTableComponent } from "./outlook-email-client-table/outlook-email-client-table.component";
import { PrimengLibraryModule } from "primeng-library";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDividerModule } from "@angular/material/divider";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EditorModule } from "@progress/kendo-angular-editor";
import { EditorLibraryModule } from "editor-library";
import { SharedModule } from '../shared/shared.module';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { IPublicClientApplication, InteractionType, BrowserCacheLocation, PublicClientApplication,LogLevel } from '@azure/msal-browser';
import { EmailClientService } from './service/email-client.service';
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { GoogleEmailClientTableComponent } from "./google-email-client-table/google-email-client-table.component";
import { GoogleEmailClientDetailComponent } from "./google-email-client-detail/google-email-client-detail.component";
import { GoogleComposeEmailComponent } from "./google-compose-email/google-compose-email.component";
import { OutlookEmailClientDetailComponent } from "./outlook-email-client-detail/outlook-email-client-detail.component";
import { OutlookComposeEmailComponent } from "./outlook-compose-email/outlook-compose-email.component";
import { MenuModule } from "primeng/menu";
import { MatChipsModule } from "@angular/material/chips";
import { MultiSelectModule } from "primeng/multiselect";
import { EmailClientLanding } from "./email-client-landing/email-client-landing";
import { UnifiedEmailComponentComponent } from "./unified-email-component/unified-email-component.component";
import { UnifiedEmailDetailsComponent } from './unified-email-component/unified-email-details/unified-email-details.component';
import { BrowserModule } from "@angular/platform-browser";
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log(message);
}

function storageFactory() : OAuthStorage {
  return localStorage
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: 'dc8268c7-af8c-4dc3-a545-12e221ddf6cb',
      // authority: 'https://login.microsoftonline.com/fa07423d-797f-4660-b37f-e3d1d8e8d479',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: window.origin
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Popup,
    authRequest: {
      scopes: ['user.read']
    }
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read','mail.read','mail.send','Mail.ReadWrite','mail.ReadBasic','Calendars.Read', 'Calendars.Read.Shared',  'Calendars.ReadWrite', 'Calendars.ReadWrite.Shared']);

  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap
  };
}

@NgModule({
  declarations: [
    EmailClientComponent,
    OutlookEmailClientTableComponent,
    OutlookEmailClientDetailComponent,
    OutlookComposeEmailComponent,
    GoogleEmailClientTableComponent,
    GoogleEmailClientDetailComponent,
    GoogleComposeEmailComponent,
    UnifiedEmailComponentComponent,
    EmailClientLanding,
    UnifiedEmailDetailsComponent
  ],
  imports: [
    CommonModule,
    EmailRoutingModule,
    PrimengLibraryModule,
    EditorModule,
    MatIconModule,
    MatMenuModule,
    MenuModule,
    MatTooltipModule,
    MatDividerModule,
    EditorLibraryModule,
    SharedModule,
    HttpClientModule,
    NgxUiLoaderModule,
    MatChipsModule,
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    { 
      provide: OAuthStorage, 
      useFactory: storageFactory },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    EmailClientService
  ],
  exports: [OutlookComposeEmailComponent]
})
export class EmailClientModule {}
